import { useTransferQueuesState } from './useTransferQueuesState';
import QueuesTable from '../QueuesTable/QueuesTable';
import { OutboundCallDetails } from '../../types';

interface TransferModalQueuesProps {
  setCallDetails: (details: OutboundCallDetails) => void;
}

const TransferModalQueues: React.FC<TransferModalQueuesProps> = ({
  setCallDetails,
}) => {
  const { queues, loading } = useTransferQueuesState();
  return (
    <QueuesTable
      queues={queues}
      loading={loading}
      setCallDetails={setCallDetails}
      initialSort={[{ field: 'name', dir: 'asc' }]}
    />
  );
};

export default TransferModalQueues;
